<template>
  <v-data-table
    :headers="headers"
    disable-filtering
    disable-pagination
    disable-sort
    hide-default-footer
    no-data-text=""
  >
    <template v-slot:body.prepend>
      <tr>
        <td>
          <v-text-field
            v-model="currFilters.name"
            :label="$t('DATA_TABLE.FILTER')"
            clearable
          ></v-text-field>
        </td>
        <td>
          <v-text-field
            v-model="currFilters.author"
            :label="$t('DATA_TABLE.FILTER')"
            clearable
          ></v-text-field>
        </td>
        <td><v-spacer /></td>
        <td>
          <v-checkbox
            v-model="currFilters.nullable_author"
            name="nullable_author"
            :label="$t('NOTIFICATIONS.SHOW_TO_ALL')"
          />
        </td>
        <td>
          <div class="d-flex">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn color="grey" depressed outlined @click="reset" v-on="on">
                  <v-icon>mdi-filter-remove</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
            </v-tooltip>
            <v-spacer class="mx-1"></v-spacer>
            <v-btn color="primary" depressed @click.prevent="setFilters">
              {{ $t('BUTTON.FIND') }}
            </v-btn>
          </div>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { mapState } from 'vuex';
import listFilters from '@/modules/_global/mixins/list-filters';

export default {
  name: 'NotificationsListFilter',

  mixins: [listFilters],

  data() {
    return {};
  },

  computed: {
    ...mapState('notification', ['filters']),
    headers() {
      return [
        {
          text: this.$t('ITEM.NAME'),
          value: 'name'
        },
        {
          text: this.$t('ITEM.AUTHOR'),
          value: 'author'
        },
        {
          text: '',
          sortable: false
        },
        {
          text: '',
          width: '220px'
        },
        {
          text: '',
          width: '150px'
        }
      ];
    }
  },

  methods: {
    reset() {
      this.currFilters = {};
      this.refreshData();
    }
  }
};
</script>

<style scoped></style>
